import { Component, Inject } from '@angular/core';
import { ProductName } from "../../account.model";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { EnumHelper, ProductCode, AccountHintData } from "common";
import { AccountPledgeFilterDialogData, AccountPledgeFilterForm, AccountPledgeFormValues } from "../account-pledge.model";
import { EntityHintData } from "../../../entity/entity.model";

@Component({
    selector: 'ifb-account-pledge-filter-dialog',
    templateUrl: './account-pledge-filter-dialog.component.html',
    standalone: false
})
export class AccountPledgeFilterDialogComponent {
  productTypeOptions = EnumHelper.getNamesAndValues(ProductName);
  form: FormGroup<AccountPledgeFilterForm>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AccountPledgeFilterDialogData,
    private readonly fb: FormBuilder,
    private readonly dialogRef: MatDialogRef<AccountPledgeFilterDialogComponent>
  ) {

    const loanNumber = this.data.queryParams?.loanNumber ? { loanNumber: this.data.queryParams.loanNumber } as AccountHintData : null;
    const companyName = this.data.queryParams?.companyName ? { businessName: this.data.queryParams.companyName } as EntityHintData : null;

    this.form = this.fb.group<AccountPledgeFilterForm>({
      companyName: new FormControl<EntityHintData | null>(companyName),
      loanNumber: new FormControl<AccountHintData | null>(loanNumber),
      offerAmountFrom: new FormControl<number | null>(this.data.queryParams.offerAmountFrom || null),
      offerAmountTo: new FormControl<number | null>(this.data.queryParams.offerAmountTo || null),
      productCode: new FormControl<ProductCode | null>(this.data.queryParams.productCode || null),
    });
  }

  onConfirmed(formValues: AccountPledgeFormValues): void {
    this.dialogRef.close({
      companyName: formValues.companyName?.businessName ?? <any>formValues.companyName,
      loanNumber: formValues.loanNumber?.loanNumber,
      offerAmountFrom: formValues.offerAmountFrom,
      offerAmountTo: formValues.offerAmountTo,
      productCode: formValues.productCode,
    });
  }
}
